import React, { useState, useEffect } from 'react'

import styled from 'styled-components'

import { Row } from '@zendeskgarden/react-grid'
import { Header, Body } from '@zendeskgarden/react-modals'
import { LG, MD } from "@zendeskgarden/react-typography"
import { Well } from '@zendeskgarden/react-notifications'
import { Button } from "@zendeskgarden/react-buttons"
import { localizeIncidentTimestamp } from '../../utils/incident'

import StatusIcon from "./StatusIcon"

const StyledModalIconDiv = styled.div`
  margin-right: 10px
`

const StyledModalTitleDiv = styled.div`
  width: 90%
`

const IncidentDetailDiv = styled.div`
  margin-bottom: 6px
  margin-top: 6px
`

const StyledModalHeader = styled.div`
  // display: flex
  justify-content: space-between
`

const ModalTextContainer = styled.div`
  margin-bottom: 10px
  margin-top: 10px
`

const ModalContents = styled.div`
`

const PostmortemContainer = styled(Row)`
  justify-content: space-between
  margin-top: 10px
  padding-left: 10px
`

const StyledModalButton = styled(Button)`
  padding-left: 4px
`

const StyledTextboxWell = styled(Well)`
  padding-left: 30px
`

const ModalDuration = ({ startedAt, maintResolvesAt, inTimezone }) => {
  return (
    <StyledModalHeader>
      <Row>
        <MD>{`Maintenance start: ${localizeIncidentTimestamp(startedAt, inTimezone)}`}</MD>
      </Row>
      <Row>
        <MD>{`Maintenance end: ${localizeIncidentTimestamp(maintResolvesAt, inTimezone)}`}</MD>
      </Row>
    </StyledModalHeader>
  )
}

const staticPostmortemText = 'For more information see the maintenance article '

const Postmortem = ({ postmortem }) => {
  return (postmortem !== '' ?
    <PostmortemContainer>
      <MD>{staticPostmortemText}
        <StyledModalButton link>
          <a href={postmortem} target="_blank" rel="noopener noreferrer"> here</a>
        </StyledModalButton>
      </MD>
    </PostmortemContainer> :
    null
  )
}

const ExternalNotes = ({ notes, postmortem }) => {
  return (notes !== '' ?
    <div>
      <ModalTextContainer>
        <LG>Maintenance information:</LG>
      </ModalTextContainer>
      <StyledTextboxWell>
        {notes}
        {postmortem && <Postmortem postmortem={postmortem} />}
      </StyledTextboxWell>
    </div> :
    null
  )
}

function hasNonEmptyMaintenanceUpdates (updates) {
  let substantiveUpdate = false
  if (updates.length > 0) {
    updates.map(update => {
      if (update.attributes.description) {
        substantiveUpdate = true
      }
    })
  }
  return substantiveUpdate
}

const ModalDetails = ({ maintenanceUpdates, inTimezone }) => {
  const updates = maintenanceUpdates ? maintenanceUpdates : []
  return (
    <div>
      <ModalTextContainer>
        <LG>{hasNonEmptyMaintenanceUpdates(updates) && 'Maintenance updates:'}</LG>
      </ModalTextContainer>
      {updates.map(update => {
        if (update.attributes.description) {
          return (
            <Well key={update.id}>
              <IncidentDetailDiv>
                <Row>{localizeIncidentTimestamp(update.attributes.createdAt, inTimezone)}:</Row>
                <Row>{update.attributes.description}</Row>
              </IncidentDetailDiv>
            </Well>
          )
        }
      })}
    </div>
  )
}

const MaintenanceModal = ({ incident, inTimezone }) => {
  const incidentAttr = incident.attributes
  const [incidentDetails, setIncidentDetails] = useState(null)

  useEffect(() => {
    const fetchIncidentDetails = async () => {
      const maintenanceUrl = `api/ssp/maintenance_incidents/${incident.id}`
      try {
        const incidentResponse = await fetch(maintenanceUrl)
        const body = await incidentResponse.json()
        setIncidentDetails(body)
      } catch(e) {
        console.log(e)
      }
    }
    incident && fetchIncidentDetails()
  }, [incident])

  return (
    <ModalContents>
      <Header>
        <Row>
          <StyledModalIconDiv>
            <StatusIcon status={'maintenance'}/>
          </StyledModalIconDiv>
          <StyledModalTitleDiv>
            <MD>{incidentAttr.name}</MD>
          </StyledModalTitleDiv>
        </Row>
      </Header>
      <Body>
        <Well>
          <ModalDuration
            startedAt={incidentAttr.startedAt}
            maintResolvesAt={incidentAttr.maintResolvesAt}
            inTimezone={inTimezone}
          />
        </Well>
        {incidentDetails && <ExternalNotes notes={incidentDetails.data.attributes.externalNotes} postmortem={incidentDetails.data.attributes.postmortem}/>}
        {incidentDetails && <ModalDetails maintenanceUpdates={incidentDetails.included.filter(i => i.type === "incidentUpdate")} inTimezone={inTimezone}/>}
      </Body>
    </ModalContents>
  )
}

export default MaintenanceModal
